import { useEffect } from "react";
import SemanticGap from './pages/dashboard/semantic-gap.tsx';
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation, Navigate } from "react-router-dom";
import { useAuthStore } from "./store/authStore";
import { Toaster } from "./components/ui/sonner";

// Pages
import LandingPage from "./pages/LandingPage";
import LoginPage from "./pages/LoginPage";
import Dashboard from "./pages/Dashboard";
import NewAnalysis from "./pages/NewAnalysis";
import ReportPage from "./pages/ReportPage";
import PricingPage from "./pages/PricingPage";
import AuthCallback from "./pages/AuthCallback";
import RankTracker from "./pages/RankTracker";
import BacklinkMonitor from "./pages/BacklinkMonitor";
import LinkBuilder from "./pages/LinkBuilder";
import GuidePage from "./pages/GuidePage";
import ContentEngine from "./pages/ContentEngine";
import TrafficPage from "./pages/TrafficPage";
import SeoActionCenter from "./pages/SeoActionCenter";
import DownloadsPage from "./pages/Downloads";
import AppShell      from './components/AppShell';
import MetaGenerator from './pages/MetaGenerator';
import InternalLinks from './pages/InternalLinks';
import OnboardingPage from "./pages/OnboardingPage";
import BeforeAfterPage from "./pages/BeforeAfterPage";

// Protected Route wrapper
function ProtectedRoute({ children }) {
  const { isAuthenticated, isLoading, checkAuth } = useAuthStore();
  const location = useLocation();

  useEffect(() => {
    checkAuth();
  }, [checkAuth]);

  if (isLoading) {
    return (
      <div className="min-h-screen bg-[#0a0a0f] flex items-center justify-center">
        <div className="w-8 h-8 border-2 border-[#7c3aed] border-t-transparent rounded-full animate-spin" />
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  return children;
}

function AppRouter() {
  const location = useLocation();
  
  if (location.hash?.includes('session_id=')) {
    return <AuthCallback />;
  }

  return (
    <Routes>
      <Route path="/" element={<LandingPage />} />
      <Route path="/login" element={<LoginPage />} />
      <Route path="/pricing" element={<PricingPage />} />
      <Route path="/guide" element={<GuidePage />} />
      <Route path="/auth/callback" element={<AuthCallback />} />
      
      {/* Protected Routes */}
      <Route path="/dashboard" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
      <Route path="/semantic-gap" element={<ProtectedRoute><SemanticGap /></ProtectedRoute>} />
      <Route path="/analysis/new" element={<ProtectedRoute><NewAnalysis /></ProtectedRoute>} />
      <Route path="/analysis/:analysisId" element={<ProtectedRoute><NewAnalysis /></ProtectedRoute>} />
      <Route path="/report/:analysisId" element={<ProtectedRoute><ReportPage /></ProtectedRoute>} />
      <Route path="/report/:analysisId/after" element={<ProtectedRoute><BeforeAfterPage /></ProtectedRoute>} />
      <Route path="/onboarding" element={<ProtectedRoute><OnboardingPage /></ProtectedRoute>} />
      <Route path="/rank-tracker" element={<ProtectedRoute><RankTracker /></ProtectedRoute>} />
      <Route path="/backlink-monitor" element={<ProtectedRoute><BacklinkMonitor /></ProtectedRoute>} />
      <Route path="/link-builder" element={<ProtectedRoute><LinkBuilder /></ProtectedRoute>} />
      <Route path="/traffic" element={<ProtectedRoute><TrafficPage /></ProtectedRoute>} />
      <Route path="/seo-action-center" element={<ProtectedRoute><AppShell><SeoActionCenter /></AppShell></ProtectedRoute>} />
      <Route path="/downloads" element={<ProtectedRoute><DownloadsPage /></ProtectedRoute>} />
      <Route path="/content-engine" element={<ProtectedRoute><ContentEngine /></ProtectedRoute>} />

      {/* Catch all - DOIT ÊTRE EN DERNIER */}
      <Route path="/meta-generator" element={<ProtectedRoute><AppShell><MetaGenerator /></AppShell></ProtectedRoute>} />
      <Route path="/internal-links" element={<ProtectedRoute><AppShell><InternalLinks /></AppShell></ProtectedRoute>} />

      <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AppRouter />
      </BrowserRouter>
      <Toaster position="top-right" />
    </div>
  );
}

export default App;
